import Axios from '@/plugins/axios'
import { onlineUrl } from '@/utils/config';

// let onlineUrl='http://192.169.31.101:15001'//baronJ本地
// 采购商搜索接口
export function buyerSearch(params) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/search`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}

// 查询采购商搜索历史列表
export function buyerSearchHistory(params={}) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/search/history/query-list`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}
// 保存采购商搜索条件接口
export function saveBuyerSearchCondition(params) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/search/history/sava-condition`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
// 保存采购商搜索历史接口
export function saveBuyerSearchHistory(params) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/search/history/sava-history`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
// 对搜索记录进行重命名
export function renameBuyerSearchRecord(params) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/search/history/rename`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}
// 删除某条搜索记录
export function deleteBuyerSearchRecord(params) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/search/history/delete`,
    method: 'POST',
    data: params,
  }
  return Axios(config);
}


// 获取采购商公司详情
export function getCompId(compId) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/company/get/${compId}`,
    method: 'GET',
  }
  return Axios(config);
}

// 获取采购商联系人详情
export function contactGet(id) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/contact/get/${id}`,
    method: 'GET',
  }
  return Axios(config);
}



// 添加采购商联系人到联系人
export function addToRecipient(params) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/add-to-customer-user`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}

// 获取我的联系人分组
export function queryMyGroup() {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/query-my-group`,
    method: 'GET',
    
  }
  return Axios(config);
}

// 把采购商公司添加为潜在客户
export function addToCustomer(params) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/company/add-to-my-customer`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 添加采购商联系人分组
export function buyerAddGroup(params) {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/add-group`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 查询国家列表
export function countryList() {
  const config = {
    url: `${ onlineUrl }/seamark/common/data-dict/country-list`,
    method: 'GET',
  }
  return Axios(config);
}

// 行业全部展示初始化
export function searchInitData() {
  const config = {
    url: `${ onlineUrl }/seamark/buyer/company/industry`,
    method: 'GET',
  }
  return Axios(config);
}
// 解除访问限制
export function unfreeze(params) {
  const config = {
    url: `${ onlineUrl }/seamark/rate-limit/unfreeze`,
    method: 'POST',
    data: params,
    noMessage:true
  }
  return Axios(config);
}
